
const urlMode = 'list'; // list 或 default
export { urlMode };
export default [
  'https://api.optewpd.com',
  'https://api.optcoma.com',
  'https://api.optcoin6.com',
  'https://api.optcomb.com',
]
